import { Flex } from "@chakra-ui/react";
import { Breadcrumb } from "src/components/Navigation/Breadcrumb";
import { useOrganization } from "src/hooks/useOrganization";
import * as BC from "src/services/breadcrumb";
import { BoundariesList } from "./BoundariesList";

export const Boundaries = () => {
  const organization = useOrganization();

  return (
    <Flex direction="column" gap={4} minHeight="100%">
      <Breadcrumb
        items={BC.organization.getBreadcrumbsForBoundaries(organization)}
      />
      <BoundariesList />
    </Flex>
  );
};
